module.exports = __webpack_public_path__ + "img/t3-1.7d75e79d.png";